import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import api from "../../api/api";
import Pagination from "../../Components/Pagination";
import usefull from './../../utils/usefull';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "../../utils/icons";
import CreateIntegration from './../../Components/Modal/IntegrationCreate';
export default function Integration(){
    const navigate = useNavigate();
    const data = [
        {
        'nom' : 'Ngassaki',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },
       {
        'nom' : 'Ngassaki',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'Ngassaki',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'SAMBA',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'MOUTOMBO',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'GOMA',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'MBOUMBA',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },

       {
        'nom' : 'MASSAMBA',
        'email' : 'ngassakisylvia@gmail.com',
        'date': '22/05/2024',
        'services': 'services',
        'APIkey':'XXX-XXX-XXX-XXXX6XXXXX',
        'date-exp':'03/03/2027',
        'date-sub':'03/03/2024',
       },


    
    ]

    const [keys, setKeys] = useState([])
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [open, setOpen] = useState(false)
    
    useEffect(()=>{

        const getData = async ()=>{
            
            try{
                
                const data = await api.get('/keys', {
                    params : {
                        page : page
                    }
                });
    
                setKeys(data.data.rows)
                setPage(page + 1)
                setTotalPage(data.data.count)
                return;
                
            }catch(e){
                
                console.log(e)
    
            }
        };

        getData()
        
    }, [currentPage])


    return(
        <div className="mx-4 my-5 overflow-hidden rounded-lg md:mx-10">

        <div className="flex flex-row items-center justify-between flex-1">
            <p className="dark:text-gray-200">Liste des clés d'API</p>
            <div 
                onClick={()=>setOpen(true)}
                className="p-2 pl-4 pr-4 m-2 text-sm text-white transition-all duration-300 bg-indigo-600 rounded-lg hover:bg-blue-800 hover:cursor-pointer hover:ring-4 ring-indigo-200">
                <span>Creer</span>
            </div>
        </div>
        <table className="w-full rounded-lg ">
            <thead>
                <tr className="bg-gray-100 dark:bg-gray-800 ">
                    <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Client</th>
                    <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">key</th>
                    <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Valide</th>
                    <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">date de creation</th>
                     
                </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-700 dark:text-gray-200">
                {
                    keys.map((item, idx)=>(
                    <tr 
                       
                        className="hover:cursor-pointer hover:bg-gray-200 hover:transition-all hover:duration-300 hover:dark:text-gray-700"
                        onClick={()=>navigate(`/parametres/integration/detailintegration/${item.id}`)}
                    >
                        <td className="px-6 py-4 border-b border-gray-200"> {item.client} </td>
                        <td className="px-6 py-4 truncate border-b border-gray-200">{item.key} </td>
                        <td className="px-6 py-4 border-b border-gray-200">{item.valid} 
                            {item.isValid === true ? <span className="p-1 pl-5 pr-5 font-bold text-green-600 bg-green-200 rounded-xl">Valide</span> : <span className="p-5 text-red-600 bg-red-200">Invalide</span>}
                        </td>
                        <td className="px-6 py-4 border-b border-gray-200">{usefull.HumanformatDate(item.createdAt)} </td>
                        
                        
                       
                        
                    </tr>
                    ))
                }
                
               
            </tbody>
        </table>

        <Pagination
            currentPage = {currentPage}
            totalPages = {totalPage}
            onPageChange = {()=>setCurrentPage(currentPage+1)}
        />

        <CreateIntegration
            open={open}
            setOpen={setOpen}
        />
    </div>
    )
}